<template>
  <div class="audio-list-content" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column prop="terminal_number" :label="$t('control.number')">
        </el-table-column>
        <el-table-column prop="terminal_ip" :label="$t('control.ip')">
          <template slot-scope="scope"> 
            <span v-if="scope.row.terminal_ip">{{ scope.row.terminal_ip }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="lamp_name" :label="$t('device.belong_lamp')"> </el-table-column>
        <el-table-column prop="volume" :label="$t('broadcast.volume')"> </el-table-column>
        <el-table-column prop="status" :label="$t('device.state')" sortable>
          <template slot-scope="scope">
            <i :class="stateIcon(scope.row.status)"></i>
            <span>{{ scope.row.status }}</span>
          </template>   
        </el-table-column>
        <el-table-column prop="date" :label="$t('control.time')">
          <template slot-scope="scope">
            <span v-if="scope.row.date">{{ scope.row.date }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
      >
        <div class="form-info">
          <el-form-item :label="$t('control.number')" prop="terminal_number">
            <el-input 
            v-model="editOne.terminal_number"
            :disabled="editType === 'create' ? false : true"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="终端IP" prop="terminal_ip">
            <el-input v-model="editOne.terminal_ip"></el-input>
          </el-form-item> -->

          <el-form-item :label="$t('broadcast.volume_start')" prop="volume">
            <el-input-number v-model="editOne.volume" :min="1" :max="100"></el-input-number>
          </el-form-item>

          <el-form-item :label="$t('camera.select_lamp')">
            <el-select
              clearable
              filterable 
              :placeholder="$t('camera.enter_select_lamp')"
              v-model="editOne.lamp_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in lampList"
                :key="t.lamp_id"
                :label="t.name"
                :value="t.lamp_id"
              ></el-option>
            </el-select>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import lampsApi from "@/api/device/lamps";
import autoListApi from "@/api/audio/audioList";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      dialogVisible: false,
      editType: -1,
      lampList: [],
      editOne: {
        terminal_number: '',
        // terminal_ip: '',
        lamp_id: '',
        volume: null
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      autoListApi.audioList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          // console.log('tableData',resData)
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getLampList()
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          terminal_number: '',
          // terminal_ip: '',
          lamp_id: '',
          volume: null
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          terminal_number: index.terminal_number,
          // terminal_ip: index.terminal_ip,
          lamp_id: index.lamp_id,
          volume: index.volume
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      autoListApi.audioEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      autoListApi.audioAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getLampList() { // 获取路灯列表
      lampsApi.lightList({
        page: 1,
        pageSize: 500,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.lampList = resData.list;
        }
      });
    },
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          autoListApi.audioDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },

    stateIcon(ste) {
      if (ste === "在线"||ste === "Online"||ste === "online") {
        return "valuegreen";
      } else {
        return "valuered";
      }
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less'>
.audio-list-content {
  width: 100%;
  .form-info{
    padding-left: 5px;
    padding-right: 0;
    .el-form-item__label{
      width:80px;
    }
  }
}
</style>